import type { TemplateTypeFilter } from "@/modules/template/types/templateType"

export const templateKeys = {
  all: ["template"] as const,
  tableList: (
    templateTypeFilter?: TemplateTypeFilter,
    filter?: { page: number; pageSize: number; searchTerm?: string },
  ) =>
    templateTypeFilter && filter
      ? ([
          ...templateKeys.all,
          "tableList",
          templateTypeFilter,
          { page: filter.page, pageSize: filter.pageSize, searchTerm: filter.searchTerm },
        ] as const)
      : templateTypeFilter
        ? ([...templateKeys.all, "tableList", templateTypeFilter] as const)
        : ([...templateKeys.all, "tableList"] as const),
  infiniteList: (
    templateTypeFilter?: TemplateTypeFilter,
    filter?: { page: number; pageSize: number; searchTerm?: string },
  ) =>
    templateTypeFilter && filter
      ? ([
          ...templateKeys.all,
          "infiniteList",
          templateTypeFilter,
          { page: filter.page, pageSize: filter.pageSize, searchTerm: filter.searchTerm },
        ] as const)
      : templateTypeFilter
        ? ([...templateKeys.all, "infiniteList", templateTypeFilter] as const)
        : ([...templateKeys.all, "infiniteList"] as const),
  item: (templateId: string) => [...templateKeys.all, "item", templateId] as const,
  element: (templateId: string) => [...templateKeys.all, "element", templateId] as const,
}
